/**
 * Contact Form.
 *
 * @format
 */

import React from 'react';
import ModalFormContainer from '../../form-components/form-containers/modal-form-container';
import { subscribeFields, newsroomSubscribeFields } from './subscribe-fields';

interface SubscribeFormProperties {
  formType?: string;
  marketoId?: string;
}

/**
 * Get Form Type.
 */
const getFormDisplayInfo = (
  formType: string
): Record<
  string,
  string | Record<string, string | null | undefined | boolean>
> | null => {
  let formInformation = null;

  switch (formType) {
    case 'centerline':
      formInformation = {
        title: 'Subscribe Centerline',
        description:
          'Welcome to Centerline, Varian’s online magazine for the clinical oncology community.  If you would like to receive an e-mail notification when new articles have been posted, please sign up below!  We will post new features and news items on a regular basis.',
        fields: subscribeFields,
      };
      break;
    case 'spoton':
      formInformation = {
        title: 'Spot ON',
        description:
          'Welcome to "Spot ON,” a quarterly e-newsletter from the Varian Particle Therapy.  This e-newsletter brings you the latest updates on our products and deployments at proton therapy centers around the world. It’s completely free to sign up and you can unsubscribe at any time (there\'s a link in every newsletter).  "Spot ON” is designed to be readable on a monitor, tablet or phone.',
        fields: subscribeFields,
      };
      break;
    case 'newsroom':
      formInformation = {
        title: 'Stay up to date',
        description: 'Sign up to receive regular news from Varian.',
        fields: newsroomSubscribeFields,
      };
      break;
  }

  return formInformation;
};

/**
 * Subscribe Form.
 *
 * @param props
 * @returns
 */
const SubscribeForm = (props: SubscribeFormProperties): JSX.Element | null => {
  const { formType, marketoId } = props;
  const displayInfo = getFormDisplayInfo(formType);
  if (displayInfo) {
    const { title, description, fields } = displayInfo;

    return (
      <ModalFormContainer
        formId={marketoId}
        formFields={fields}
        formType={`subscribe-form`}
        formTitle={title}
        formDescription={description}
        linkType={`button`}
        linkText={`Subscribe Now`}
        linkClasses={`btn-primary`}
      />
    );
  }
  return null;
};
export default SubscribeForm;
